var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
const SvgFlagLv = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 9,
    viewBox: "0 0 18 9",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 3,
    fill: "#9f2c36"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 3,
    y: 3,
    fill: "#FFF"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 3,
    y: 6,
    fill: "#9f2c36"
  }))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgFlagLv, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/flag-lv.67155bb6.svg";
export { ForwardRef as ReactComponent };